export default __webpack_public_path__ + "static/media/480_portfolio03-fr-web.e92497c4.png";